import { render, staticRenderFns } from "./jiaoyanguanli.vue?vue&type=template&id=2526836d&scoped=true&"
import script from "./jiaoyanguanli.vue?vue&type=script&lang=ts&"
export * from "./jiaoyanguanli.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526836d",
  null
  
)

export default component.exports